import Cookies from 'js-cookie';
import CacheInstance from '../components/cache';

const userLoggedIn = (options = {}) => {

  return new Promise((resolve, reject) => {

    let token = window.localStorage.getItem('token');

    if(!token) {
      token = Cookies.get('token');

      if(token) {
        token = decodeURIComponent(token);
      }

    }

    if(token) {

      window.apiRequest('post', '/authenticate').then(r => {

        if(r.type === 'success') {

          const data = r.data;

          Cookies.set('token', encodeURIComponent(data.token), { expires: 365 });

          window.localStorage.setItem('token', data.token);
          window.currentUser = data.user;

          CacheInstance.save('authenticate', data);

          window.PubSub.publish('user_authenticated', data.user);
          resolve(data.token);

        } else {
          resolve(false);
        }

      });

    } else {
      resolve(false);
    }

  });

};

export default userLoggedIn;
